module.exports = __webpack_public_path__ + "static/media/Company_VCF_Guide.4d2c98a5.pdf";